import React from 'react';
import {
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import Page from '../../../components/Page';

import parseUrl from '../../../utils/parseUrl';
import CertificateForm from '../CertificateForm/CertificateForm';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CertificateFormPage = () => {
  const classes = useStyles();

  const certificateId = parseUrl(3);

  return (
    <Page
      className={classes.root}
      title="Пролонгация полиса"
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
        >
          <CertificateForm certificateId={certificateId} prolongMode={true} />
        </Grid>
      </Container>
    </Page>
  );
};

export default CertificateFormPage;
